export function extend(obj) {
  var length = arguments.length
  if (length < 2 || obj == null) return obj
  for (var index = 1; index < length; index++) {
    var source = arguments[index],
      keys = Object.keys(source),
      l = keys.length
    for (var i = 0; i < l; i++) {
      var key = keys[i]
      if (obj[key] === void 0) obj[key] = source[key]
    }
  }
  return obj
}

/**
 * 检测一个对象是否为空
 * 为空返回 true
 * 非空返回 false
 * @param obj
 * @returns {boolean}
 */
export function isObjectEmpty(obj) {
  for (let key in obj) {
    return false
  }
  return true
}

/**
 * 注意这里使用自定义 base64
 * 主要是由于 window.btoa 只能编码 ASCII 码
 * 需要 encode 后再 btoa, 但是某些cgi 不需要 encode
 * 故此重新声明 base64
 * @param input
 * @returns {string}
 */
export function base64encode(input) {
  let keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
  let output = ""
  let chr1, chr2, chr3, enc1, enc2, enc3, enc4
  let i = 0

  let utf8Encode = function(string) {
    string = string.replace(/\r\n/g, "\n")
    let utftext = ""
    for (let n = 0; n < string.length; n++) {
      let c = string.charCodeAt(n)
      if (c < 128) {
        utftext += String.fromCharCode(c)
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode((c >> 6) | 192)
        utftext += String.fromCharCode((c & 63) | 128)
      } else {
        utftext += String.fromCharCode((c >> 12) | 224)
        utftext += String.fromCharCode(((c >> 6) & 63) | 128)
        utftext += String.fromCharCode((c & 63) | 128)
      }
    }
    return utftext
  }
  input = utf8Encode(input)
  while (i < input.length) {
    chr1 = input.charCodeAt(i++)
    chr2 = input.charCodeAt(i++)
    chr3 = input.charCodeAt(i++)
    enc1 = chr1 >> 2
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
    enc4 = chr3 & 63
    if (isNaN(chr2)) {
      enc3 = enc4 = 64
    } else if (isNaN(chr3)) {
      enc4 = 64
    }
    output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4)
  }
  return output
}

export function clone(obj) {
  var str,
    newobj = obj.constructor === Array ? [] : {}
  if (typeof obj !== "object") {
    return
  } else if (window.JSON) {
    str = JSON.stringify(obj)
    //系列化对象
    newobj = JSON.parse(str)
    //还原
  } else {
    for (var i in obj) {
      newobj[i] = typeof obj[i] === "object" ? clone(obj[i]) : obj[i]
    }
  }
  return newobj
}

/**
 * 限制频率 throttle 函数
 * @param func
 * @param wait
 * @param options
 * @returns {function(): *}
 */
export function throttle(func, wait, options) {
  let timeout, context, args, result
  let previous = 0
  if (!options) options = {}

  const later = function() {
    previous = options.leading === false ? 0 : Date.now()
    timeout = null
    result = func.apply(context, args)
    if (!timeout) context = args = null
  }

  const throttled = function() {
    let now = Date.now()

    if (!previous && options.leading === false) previous = now

    let remaining = wait - (now - previous)

    context = this
    args = arguments
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      previous = now
      result = func.apply(context, args)
      if (!timeout) context = args = null
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining)
    }
    return result
  }

  throttled.cancel = function() {
    clearTimeout(timeout)
    previous = 0
    timeout = context = args = null
  }

  return throttled
}

/**
 * 绑定事件
 * @param elem 绑定元素
 * @param type 事件类型
 * @param handler 绑定事件函数
 * @param param 绑定事件函数的参数
 */
export function addEvent(elem, type, handler, param = "") {
  let func = handler
  if (param) {
    func = function() {
      handler.call(this, param) //继承监听函数,并传入参数以初始化
    }
  }
  if (window.addEventListener) {
    elem.addEventListener(type, func, false)
  } else if (window.attachEvent) {
    elem.attachEvent("on" + type, func)
  } else {
    elem["on" + type] = func
  }
}

/**
 * 解绑事件
 * @param elem 绑定元素
 * @param type 事件类型
 * @param fnName 绑定事件函数
 */
export function removeEvent(elem, type, fnName) {
  if (elem.removeEventListener) {
    elem.removeEventListener(type, fnName, false)
  } else if (elem.detachEvent) {
    elem.detachEvent("on" + type, fnName)
  } else {
    elem["on" + type] = null
  }
}

// 数字转中文大写
export function numberToChinese(num) {
  let AA = new Array("零", "一", "二", "三", "四", "五", "六", "七", "八", "九", "十")
  let BB = new Array("", "十", "百", "仟", "萬", "億", "点", "")
  let a = ("" + num).replace(/(^0*)/g, "").split("."),
    k = 0,
    re = ""
  for (let i = a[0].length - 1; i >= 0; i--) {
    switch (k) {
      case 0:
        re = BB[7] + re
        break
      case 4:
        if (!new RegExp("0{4}//d{" + (a[0].length - i - 1) + "}$").test(a[0])) re = BB[4] + re
        break
      case 8:
        re = BB[5] + re
        BB[7] = BB[5]
        k = 0
        break
    }
    if (k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0) re = AA[0] + re
    if (a[0].charAt(i) != 0) re = AA[a[0].charAt(i)] + BB[k % 4] + re
    k++
  }
  if (re == "一十") re = "十"
  if (re.match(/^一/) && re.length == 3) re = re.replace("一", "")
  return re
}

// qq session类型
export function isQQSessionType(sessiontype) {
  const isQQType = ["skey", "kp_actoken", "kp_accesstoken"]
  return isQQType.indexOf(sessiontype) > -1 || (sessiontype && sessiontype.indexOf("pskey_") > -1)
}

// 压缩图片
export function compressImage(file) {
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function(event) {
      const img = new Image()
      img.src = event.target.result
      img.onload = function() {
        const canvas = document.createElement("canvas")
        const ctx = canvas.getContext("2d")
        const width = img.width > 1000 ? 1000 : img.width // 目标宽度，这里设置为1000像素
        const height = img.height * (width / img.width)
        canvas.width = width
        canvas.height = height
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
        const newDataUrl = canvas.toDataURL("image/jpeg", 0.5)
        resolve(newDataUrl)
      }
    }
  })
}
// 计算base64图片大小
export function getBase64ImageSizeInKB(base64) {
  let str = atob(base64.split(",")[1])
  let bytes = str.length
  let sizeInKB = bytes / 1024
  return sizeInKB
}

export function getEnv(sandbox) {
  let env = ""
  if (sandbox == 1) {
    env = "sandbox."
  }
  if (sandbox == 2) {
    env = "dev."
  }
  if (sandbox == 3) {
    env = "testing."
  }
  return env
}

// 删除url中某个参数（不刷新页面）
export function removeParam(param) {
  let url = new URL(location.href)
  url.searchParams.delete(param)
  window.history.replaceState({}, "", url.toString())
}

export function removeCookie(key, opts) {
  opts = opts || {}
  const expires = "Thu, 01 Jan 1970 00:00:00 UTC"
  const path = opts.path || "/"
  const domain = opts.domain || document.domain
  document.cookie = key + "=" + "; expires=" + expires + "; path=" + path + "; domain=" + domain
}
